﻿import { IEwtSummary } from '../ewt-summary';
import { IEwtCounts } from '../ewt-counts';

export interface IMiracleMatch {
    [key: string]: string | number | boolean | IEwtSummary | IEwtCounts;
    recipientCenter: string;
    recipientCenterId: number;
    recipientId: number;
    recipientAlias: string;
    recipientBloodType: string;
    recipientIsExportable: boolean;
    oTiterString: string;
    maxDonorAge: number;
    minHLAMatch: number;
    cPRA4: number;
    rAge: number;
    donorBloodType: string;
    firstDonorBloodType: string;
    dAge: string;
    dmp: string;
    rmPa: number;
    rmPb: number;
    rmPc: number;
    pmPa: number;
    pmPb: number;
    pmPc: number;
    erosion: number;
    dialysis: string;
    ewt: string;
    wtv: string;
    wait: number;
    exportableDaysInNkr: number;
    ssdHit: number;
    clc: number;
    fclc: number;
    usableCLC: number;
    onlyDonorIdMatchC: number;
    onlyDonorMatchCAlias: string;
    onlyDonorMatchCCenter: string;
    rexmStatus: string;
    ewtSummary: IEwtSummary;
    initialCount: IEwtCounts;
    highPra: boolean;
    declineRatio: number;
    donorInMatch: boolean;
    sortOrder: number;
}
